import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/i42.png'
import _imports_1 from '@/assets/i43.png'
import _imports_2 from '@/assets/i119.jpg'
import _imports_3 from '@/assets/i44.png'
import _imports_4 from '@/assets/i45.png'
import _imports_5 from '@/assets/logo2.png'
import _imports_6 from '@/assets/i47.png'
import _imports_7 from '@/assets/i48.png'
import _imports_8 from '@/assets/i49.png'
import _imports_9 from '@/assets/i50.png'
import _imports_10 from '@/assets/i38.png'
import _imports_11 from '@/assets/i98.png'
import _imports_12 from '@/assets/i99.png'
import _imports_13 from '@/assets/quesheng.png'
import _imports_14 from '@/assets/i101.png'
import _imports_15 from '@/assets/i102.png'


const _withScopeId = n => (_pushScopeId("data-v-49e6f5f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "navBox" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "rightBox" }
const _hoisted_5 = { class: "search" }
const _hoisted_6 = { class: "btnBox" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"btn btn2\" data-v-49e6f5f1><img class=\"i\" src=\"" + _imports_1 + "\" alt=\"\" srcset=\"\" data-v-49e6f5f1><div class=\"t\" data-v-49e6f5f1>移动端查看数据</div><div class=\"wxCode\" data-v-49e6f5f1><img class=\"img\" src=\"" + _imports_2 + "\" alt=\"\" srcset=\"\" data-v-49e6f5f1></div></div><div class=\"line\" data-v-49e6f5f1></div>", 2)
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t" }, "通知", -1))
const _hoisted_11 = {
  key: 0,
  class: "dian"
}
const _hoisted_12 = { class: "userInfo" }
const _hoisted_13 = { class: "tbox" }
const _hoisted_14 = { class: "t" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_4,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_16 = { class: "moreInfo" }
const _hoisted_17 = { class: "box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ttop" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "i",
    src: _imports_5,
    alt: "",
    srcset: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "t" }, "欢迎登录找磁材")
], -1))
const _hoisted_19 = { class: "name" }
const _hoisted_20 = { class: "itemBox" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_6,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t" }, "账号管理", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_7,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t" }, "设备管理", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_8,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t" }, "续费管理", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_9,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t" }, "退出", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "messageDrawer" }
const _hoisted_35 = { class: "titleMessage" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t" }, "消息通知", -1))
const _hoisted_37 = { class: "n" }
const _hoisted_38 = {
  key: 0,
  class: "listBox"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "imgBox" }
const _hoisted_41 = {
  key: 0,
  class: "i",
  src: _imports_11,
  alt: "",
  srcset: ""
}
const _hoisted_42 = {
  key: 1,
  class: "i",
  src: _imports_12,
  alt: "",
  srcset: ""
}
const _hoisted_43 = { class: "name" }
const _hoisted_44 = { class: "msg" }
const _hoisted_45 = {
  key: 1,
  class: "noData"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_13,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t" }, "暂无消息通知", -1))
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_14,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t" }, "全部已读", -1))
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = { class: "titleMessage" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t" }, "信息详情", -1))
const _hoisted_54 = { class: "messageDrawerDetail" }
const _hoisted_55 = { class: "top" }
const _hoisted_56 = { class: "t" }
const _hoisted_57 = { class: "time" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_15,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_59 = { class: "tt" }
const _hoisted_60 = { class: "msgInfo" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t" }, "返回", -1))
const _hoisted_62 = [
  _hoisted_61
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", { 'has-bg': _ctx.isBackgroundVisible }]),
    style: _normalizeStyle({position:_ctx.positionFixed?'fixed':'sticky'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onIndex()), ["stop"]))
      }),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indexNavTop, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["nav", _ctx.navIdx == index?'active':'']),
            key: index,
            onClick: ($event: any) => (_ctx.onNav(item,index))
          }, _toDisplayString(item.title), 11, _hoisted_3))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.searchKey,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchKey) = $event)),
            placeholder: "请输入关键词",
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.searchResults()), ["enter"]))
          }, null, 8, ["modelValue"]),
          _createElementVNode("img", {
            class: "i",
            src: _imports_0,
            alt: "",
            srcset: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchResults()))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getMessageDrawer && _ctx.getMessageDrawer(...args)))
          }, [
            _hoisted_9,
            _hoisted_10,
            (_ctx.totalMsgNo > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.userInfo.company), 1),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.userInfo.company), 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", {
                  class: "item",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.companyPanel(1)))
                }, _hoisted_23),
                _createElementVNode("div", {
                  class: "item",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.companyPanel(2)))
                }, _hoisted_26),
                _createElementVNode("div", {
                  class: "item",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.companyPanel(3)))
                }, _hoisted_29)
              ]),
              _createElementVNode("div", {
                class: "out",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loginOut()))
              }, _hoisted_32)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.indexNavTop.length > 0 && _ctx.navShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["navBoxChild", { 'has-bg2': _ctx.isBackgroundVisible }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["item", _ctx.navChildIdx == null || _ctx.navChildIdx == 'null'?'active':'']),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onNavChild(null,{id:null})))
          }, "首页", 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indexNavTop[_ctx.navIdx]?.children, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item", _ctx.navChildIdx == item.id?'active':'']),
              onClick: ($event: any) => (_ctx.onNavChild(index,item))
            }, _toDisplayString(item.title), 11, _hoisted_33))
          }), 256))
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_34, [
      _createVNode(_component_el_drawer, {
        class: "messageDrawer1",
        modelValue: _ctx.messageDrawer,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.messageDrawer) = $event)),
        "z-index": 9999999,
        size: "480",
        "show-close": false,
        "lock-scroll": false
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, "（" + _toDisplayString(_ctx.totalMsgNo) + "条未读）", 1),
            _createElementVNode("img", {
              class: "i",
              src: _imports_10,
              alt: "",
              srcset: "",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.messageDrawerClose()))
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_scrollbar, {
            height: "100%",
            ref: "listBoxMsg",
            onScroll: _ctx.handleScrollMsg,
            always: false
          }, {
            default: _withCtx(() => [
              (_ctx.msgListData.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.msgListData, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "list",
                        key: index,
                        onClick: ($event: any) => (_ctx.getmessageDrawerDetail(item))
                      }, [
                        _createElementVNode("div", _hoisted_40, [
                          (item.is_read == 1)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_41))
                            : (_openBlock(), _createElementBlock("img", _hoisted_42))
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["info", item.is_read == 1?'no':''])
                        }, [
                          _createElementVNode("div", _hoisted_43, _toDisplayString(item.title), 1),
                          _createElementVNode("div", _hoisted_44, _toDisplayString(item.content), 1)
                        ], 2)
                      ], 8, _hoisted_39))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_48))
            ]),
            _: 1
          }, 8, ["onScroll"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", {
            class: "btnBox",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.msgAllRead && _ctx.msgAllRead(...args)))
          }, _hoisted_51)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_drawer, {
        class: "messageDrawer1",
        modelValue: _ctx.messageDrawerDetail,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.messageDrawerDetail) = $event)),
        "z-index": 9999999,
        size: "480",
        modal: false,
        "show-close": false,
        "lock-scroll": false
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("img", {
              class: "i",
              src: _imports_10,
              alt: "",
              srcset: "",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onClosemessageDrawerDetail()))
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.msgListDataDetails.title), 1),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.msgListDataDetails.create_time), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", null, [
                _createElementVNode("pre", null, _toDisplayString(_ctx.msgListDataDetails.content), 1)
              ])
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", {
            class: "btnBox2",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onClosemessageDrawerDetail()))
          }, _hoisted_62)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 6))
}